import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomAlertComponent } from './custom-alert.component';

@NgModule({
  imports: [CommonModule],
  declarations: [CustomAlertComponent],
  exports: [CustomAlertComponent]
})
export class CustomAlertModule {}
